import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EmailTemplatestable from "../../components/EmailTemplates/EmailTemplatestable";
import AddEmailTemp from "../../components/EmailTemplates/AddEmailTemp";

const AddTemplatePage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Add Email Templates" subUrl={"email-templates"} subtitle={"Email Template"}/>
                <AddEmailTemp />


            </MasterLayout>
        </>
    );
};

export default AddTemplatePage;
